__turbopack_context__.v({
  "wrapper": "Wrapper-module-scss-module__9oBAHq__wrapper",
});
